export { HasAccessForPlatformQuery } from './queries';
export { ChangePasswordMutation, RefreshTokenMutation, RevokeTokenMutation } from './mutations';
